var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-item"},[_c('h1',[_vm._v("Pages "),_c('router-link',{staticClass:"btn-edit",attrs:{"to":"/pages/edit/22"}},[_c('i',{staticClass:"fa fa-pen"})])],1)]),_c('router-view',{attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }